/**
 * Máquina por etapa do roteiro da Ficha Técnica — subcoleção.
 * Subcoleção: org/{orgId}/technical-sheet/{technicalSheetId}/route/{routeId}/routeMachine
 */
export const TECHNICAL_SHEET_ROUTE_MACHINE = 'TechnicalSheetRouteMachine';
//# sourceMappingURL=technical-sheet-route-machine.js.map